export function stripNonNumeric(value: string | number): number | null {
    return Number(value.toString().replace(/[^0-9.-]+/g, ''));
}
